<template>
  <div class="col-6">
    <div class="flex field w-full">
      <div class="w-full flex gap-2 flex-column">
        <label for="vinculo">{{ valueName }}</label>
        <InputText
          id="vinculo"
          class="input mt-2"
          type="text"
          :placeholder="valueName"
          v-model="dataValue"
          test-id="inputVinculo"
          @blur="blurInputEvent"
        />
      </div>
      <div class="flex justify-content-end ml-auto w-3rem">
        <Button
          icon="pi pi-plus"
          class="p-button-rounded p-button-info p-button-outlined pasteInto plus-button ml-5"
          :disabled="addButtonDisabled"
          v-tooltip.left="tooltip"
          @click="addItemToListboxistBoxOptions"
        />
      </div>
    </div>
    <p class="item-error" v-if="minLengthError">
      Este campo necesita mínimo {{ minLength }} caracteres
    </p>
    <p class="item-error" v-if="maxLengthError">
      Este campo no puede tener más de {{ maxLength }} caracteres
    </p>
    <p class="item-error" v-if="itemErrorRepeated">
      El nuevo item de "{{ valueName }}" que intenta ingresar está repetido
    </p>
    <div>
      <Listbox
        v-model="listboxValue"
        :options="listBoxOptions"
        dataKey="arrId"
        optionValue="arrId"
        optionLabel="name"
      >
        <template #option="slotProps">
          <div v-if="listBoxOptions.length > 0" class="flex">
            <p>
              {{
                slotProps.option?.[subPropName] !== undefined
                  ? slotProps.option?.[subPropName]
                  : slotProps.option
              }}
            </p>
            <Button
              v-if="slotProps.option !== 'Sin Datos'"
              icon="pi pi-trash"
              class="p-button-danger p-button-lg px-2 py-2 m-1 ml-auto"
              style="z-index: 3"
              v-tooltip.right="'Eliminar Item'"
              @click="deleteItem(slotProps.option)"
            />
          </div>
        </template>
      </Listbox>
    </div>
  </div>
</template>
<script setup>
import { ref, computed, watch, onMounted } from "vue";
import Button from "primevue/button";
import Listbox from "primevue/listbox";
import InputText from "primevue/inputtext";

const props = defineProps({
  Prop_FormPersona_update: Function,
  defaultValue: Array,
  formDataName: String,
  valueName: String,
  tooltip: String,
  preventRepeatedItems: Boolean,
  minLength: Number,
  maxLength: Number,
  subPropName: String,
});

const emit = defineEmits(["updateList"]);

const listboxValue = ref("");
const value = ref("");
const addButtonDisabled = ref(true);
const minLengthError = ref(false);
const maxLengthError = ref(false);
const itemErrorRepeated = ref(false);
const listBoxOptions = ref(["Sin Datos"]);

onMounted(() => {
  listBoxOptions.value = [...props.defaultValue];
});

watch(listBoxOptions, (newValue) => {
  const hasNoDataOption = listBoxOptions.value.some((item) => item === "Sin Datos");
  if (newValue.length === 0) {
    listBoxOptions.value = ["Sin Datos"];
  }
  if (newValue.length > 1 && hasNoDataOption) {
    listBoxOptions.value = listBoxOptions.value.filter((item) => item !== "Sin Datos");
    emit("updateList", props.formDataName, listBoxOptions.value);
  }
});

const dataValue = computed({
  get: () => value.value,
  set: (newValue) => {
    if (
      listBoxOptions.value.some((item) => item?.[props.subPropName] === newValue) &&
      props.preventRepeatedItems
    ) {
      addButtonDisabled.value = true;
      itemErrorRepeated.value = true;
      value.value = newValue;
      return;
    } else {
      addButtonDisabled.value = false;
      itemErrorRepeated.value = false;
    }

    if (newValue.length >= props.minLength && newValue.length <= props.maxLength) {
      minLengthError.value = false;
      maxLengthError.value = false;
      addButtonDisabled.value = false;
    } else {
      addButtonDisabled.value = true;
    }
    value.value = newValue;
  },
});

const addItemToListboxistBoxOptions = () => {
  listBoxOptions.value = [...listBoxOptions.value, value.value];
  emit("updateList", props.formDataName, listBoxOptions.value);
  value.value = "";
  addButtonDisabled.value = true;
};

const blurInputEvent = () => {
  minLengthError.value = false;
  maxLengthError.value = false;
  if (value.value.length < props.minLength) minLengthError.value = true;
  if (value.value.length > props.maxLength) maxLengthError.value = true;
  if (value.value.length === 0) minLengthError.value = false;
};

const deleteItem = (IDToDelete) => {
  listBoxOptions.value = listBoxOptions.value.filter((item) => item !== IDToDelete);
  emit("updateList", props.formDataName, listBoxOptions.value);
};
</script>

<style>
.plus-button {
  margin-top: 27px;
}
.item-error {
  color: #dc3545;
  font-size: 14px;
  margin-top: -5px;
}
</style>
